import api from 'shared/api'

export const forgotPassword = async ({ email }) => {
  await api.post('/auth/forgot-password', { email })
}
